module.exports = __webpack_public_path__ + "static/media/immunity.b8d83a7c.png";